import { quickProperty, designToken } from '../component-tokens';
import { sizeAttributes } from './utils';
const tile = {
    name: 'tile',
    tag: 'li',
    attributes: {
        'background-color': designToken('ui-05'),
        margin: quickProperty('0 4px'),
        flex: quickProperty('1'),
        transition: quickProperty('500ms all'),
    },
};
const tileActive = Object.assign(Object.assign({}, tile), { name: 'tile-active', attributes: Object.assign(Object.assign({}, tile.attributes), { 'background-color': designToken('interactive-01') }) });
const dot = {
    name: 'dot',
    tag: 'li',
    attributes: Object.assign(Object.assign({}, sizeAttributes('8px')), { 'background-color': designToken('ui-05'), 'border-radius': quickProperty('50%'), margin: quickProperty('0 4px'), transition: quickProperty('500ms all') }),
};
const dotActive = Object.assign(Object.assign({}, dot), { name: 'tile-active', attributes: Object.assign(Object.assign({}, dot.attributes), { 'background-color': designToken('interactive-01') }) });
export const linearProgressIndicator = {
    name: 'linear',
    tag: 'div',
    attributes: {
        'background-color': designToken('ui-05'),
        height: quickProperty('4px'),
        'border-radius': quickProperty('24px'),
    },
    children: [
        {
            name: 'indicator',
            content: ' ',
            tag: 'div',
            attributes: {
                'background-color': designToken('interactive-01'),
                'border-radius': quickProperty('24px'),
                height: quickProperty('4px'),
            },
        },
    ],
};
export const progressIndicatorTokens = {
    name: 'progress-indicator',
    reactImports: 'ProgressIndicator',
    variants: [
        linearProgressIndicator,
        Object.assign(Object.assign({}, linearProgressIndicator), { name: 'linear-inverse', attributes: Object.assign(Object.assign({}, linearProgressIndicator.attributes), { 'background-color': designToken('inverse-ui-05') }), children: [
                Object.assign(Object.assign({}, linearProgressIndicator.children[0]), { attributes: Object.assign(Object.assign({}, linearProgressIndicator.children[0].attributes), { 'background-color': designToken('inverse-interactive-01') }) }),
            ] }),
        {
            name: 'tiles',
            tag: 'ul',
            attributes: {
                height: quickProperty('4px'),
                'list-style': quickProperty('none'),
                display: quickProperty('flex'),
                margin: quickProperty('0'),
                padding: quickProperty('0'),
            },
            children: [tileActive, tileActive, tile, tile, tile],
        },
        {
            name: 'dots',
            tag: 'ul',
            attributes: {
                height: quickProperty('8px'),
                'list-style': quickProperty('none'),
                display: quickProperty('flex'),
                margin: quickProperty('0'),
                padding: quickProperty('0'),
            },
            children: [dotActive, dot, dot],
        },
    ],
};
